var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.208,23a7.792,7.792,0,0,0,6.3-12.375l-6.7-9.213a1.038,1.038,0,0,0-1.618,0l-6.7,9.213A7.792,7.792,0,0,0,10.792,23ZM5,15.208A5.757,5.757,0,0,1,6.107,11.8L12,3.7l5.893,8.1A5.792,5.792,0,0,1,13.208,21H10.792A5.8,5.8,0,0,1,5,15.208Zm6.245,4.042a5.238,5.238,0,0,1-4.63-2.779,1,1,0,1,1,1.764-.942,3.242,3.242,0,0,0,2.866,1.721,1,1,0,0,1,0,2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterDrop);
export default __webpack_public_path__ + "static/media/water-drop.0013691d1b0dcfaa236471134684a2e4.svg";
export { ForwardRef as ReactComponent };